import { render, staticRenderFns } from "./AboutPosters.vue?vue&type=template&id=78d45aa2&scoped=true&"
var script = {}
import style0 from "./AboutPosters.vue?vue&type=style&index=0&id=78d45aa2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78d45aa2",
  null
  
)

export default component.exports